import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { TrendManagementSettingType, createDefaltTrendSetting, GetTrendSettingList } from './TrendGraph';

const useStyles = makeStyles(
  createStyles({
    tableTitleCell: {
      maxWidth: '30px',
      minWidth: '30px',
      padding: '1px',
      textAlign: 'right',
      fontSize: '15px',
      borderBottomWidth: '0px',
    },
    tableCell: {
      border: '1px solid rgba(0, 0, 0, 1)',
      backgroundColor: 'white',
      maxWidth: '30px',
      minWidth: '30px',
      padding: '1px',
      textAlign: 'center',
    },
    tableSelectCell: {
      border: '1px solid rgba(0, 0, 0, 1)',
      backgroundColor: '#FFFFBB',
      maxWidth: '30px',
      minWidth: '30px',
      padding: '1px',
      textAlign: 'center',
    },
  })
);

type Props = {
  date1: string;
  date2: string;
  date3: string;
  selectIndex: number;
  onChangeDateSelectIndex: (index: number) => void;
  onDeleteDateSelectIndex: (index: number) => void;
};

const TrendGraphDaySelects: React.FC<Props> = (props) => {
  console.debug('==TrendGraphDaySelects==');

  const classes = useStyles();
  const { t } = useTranslation();

  const handleDataCellClick = (selectIndex: number) => {
    props.onChangeDateSelectIndex(selectIndex);
  };

  const onDataCellDoubleClick = (selectIndex: number) => {
    props.onDeleteDateSelectIndex(selectIndex);
  };

  return (
    <Table style={{ height: '10px', width: '400px' }}>
      <TableBody>
        <TableRow>
          <TableCell className={classes.tableTitleCell}>{t('TrendGraphDaySelects.日付選択', '日付選択：')}</TableCell>
          <TableCell
            className={props.selectIndex === 1 ? classes.tableSelectCell : classes.tableCell}
            onClick={() => handleDataCellClick(1)}
            onDoubleClick={(e) => onDataCellDoubleClick(1)}
          >
            {props.date1}
          </TableCell>
          <TableCell
            className={props.selectIndex === 2 ? classes.tableSelectCell : classes.tableCell}
            onClick={() => handleDataCellClick(2)}
            onDoubleClick={(e) => onDataCellDoubleClick(2)}
          >
            {props.date2}
          </TableCell>
          <TableCell
            className={props.selectIndex === 3 ? classes.tableSelectCell : classes.tableCell}
            onClick={() => handleDataCellClick(3)}
            onDoubleClick={(e) => onDataCellDoubleClick(3)}
          >
            {props.date3}
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
};

export default TrendGraphDaySelects;
